var _path, _path2, _circle, _line, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorDisability(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m23.931,28.411c-1.06,1.952-3.129,3.277-5.506,3.277-3.458,0-6.262-2.804-6.262-6.262,0-2.14,1.074-4.03,2.712-5.159"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m16.907,14.702l.517,6.906c.038.506.46.898.967.898h5.132c.383,0,.73.225.886.575l2.356,5.293c.155.348.551.519.911.394l2.161-.755"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.532,
    cy: 12.507,
    r: 2.195
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 22.91,
    y1: 18.811,
    x2: 17.272,
    y2: 18.811
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 18.549
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorDisability);
export default __webpack_public_path__ + "static/media/indoor-disability.5863e1ca4c6667d8d461da20dcf37126.svg";
export { ForwardRef as ReactComponent };